import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Apps from './components/Apps';
import Libraries from './components/Libraries';
import Resume from './components/Resume';
import './App.css';

function Navigation(): JSX.Element {  
  const location = useLocation();

  const isActive = (path: string): boolean => {
    return location.pathname === path;
  };

  return (
    <nav className="navbar-default">
      <div className="container" style={{ padding: 0, width: '100%' }}>
        <div className="navbar-header">
          <ul className="nav navbar-nav">
            <li className={isActive('/resume') ? 'active' : ''}>
              <Link to="/resume">resume</Link>
            </li>
            <li className={isActive('/apps') ? 'active' : ''}>
              <Link to="/apps">apps</Link>
            </li>
            <li className={isActive('/libs') ? 'active' : ''}>
              <Link to="/libs">libs</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

function App(): JSX.Element {
  useEffect(() => {
    // Simple particle background effect
    const canvas = document.createElement('canvas');
    canvas.className = 'background';
    canvas.style.position = 'fixed';
    canvas.style.top = '0';
    canvas.style.left = '0';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.zIndex = '-1';
    document.body.appendChild(canvas);

    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    
    let particles: Array<{x: number, y: number, vx: number, vy: number, size: number}> = [];

    const resizeCanvas = (): void => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    const createParticle = (): {x: number, y: number, vx: number, vy: number, size: number} => {
      return {
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.5,
        vy: (Math.random() - 0.5) * 0.5,
        size: Math.random() * 3 + 1
      };
    };

    const initParticles = (): void => {
      particles = [];
      const particleCount = Math.min(100, Math.floor((canvas.width * canvas.height) / 10000));
      for (let i = 0; i < particleCount; i++) {
        particles.push(createParticle());
      }
    };

    const updateParticles = (): void => {
      particles.forEach(particle => {
        particle.x += particle.vx;
        particle.y += particle.vy;

        if (particle.x < 0 || particle.x > canvas.width) particle.vx *= -1;
        if (particle.y < 0 || particle.y > canvas.height) particle.vy *= -1;
      });
    };

    const drawParticles = (): void => {
      if (!ctx) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      particles.forEach(particle => {
        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
        ctx.fillStyle = '#75A5B7';
        ctx.fill();
      });

      // Draw connections
      for (let i = 0; i < particles.length; i++) {
        for (let j = i + 1; j < particles.length; j++) {
          const dx = particles[i].x - particles[j].x;
          const dy = particles[i].y - particles[j].y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < 150) {
            ctx.beginPath();
            ctx.moveTo(particles[i].x, particles[i].y);
            ctx.lineTo(particles[j].x, particles[j].y);
            ctx.strokeStyle = `rgba(117, 165, 183, ${0.5 * (1 - distance / 150)})`;
            ctx.lineWidth = 1;
            ctx.stroke();
          }
        }
      }
    };

    const animate = (): void => {
      updateParticles();
      drawParticles();
      requestAnimationFrame(animate);
    };

    resizeCanvas();
    initParticles();
    animate();

    window.addEventListener('resize', () => {
      resizeCanvas();
      initParticles();
    });

    return () => {
      window.removeEventListener('resize', resizeCanvas);
      document.body.removeChild(canvas);
    };
  }, []);

  return (
    <Router>
      <div className="container-fluid" style={{ padding: 0, width: '100%' }}>
        <div className="row">
          <div className="col-sm-3 col-lg-2 sidebar">
            <Navigation />
          </div>
          <div className="col-sm-9 col-lg-10 main-view">
            <Routes>
              <Route path="/" element={<Resume />} />
              <Route path="/resume" element={<Resume />} />
              <Route path="/apps" element={<Apps />} />
              <Route path="/libs" element={<Libraries />} />
            </Routes>
          </div>
        </div>
        <canvas className="background"></canvas>
      </div>
    </Router>
  );
}

export default App;
